export default "__VITE_ASSET__CdFimHWb__"